import { ACTIVITY } from '../../config/activity';

import './ActivityDisplay.scss';

interface ActivityDisplayProps {
  activity: keyof typeof ACTIVITY | null;
  showLabel?: boolean;
  customLabel?: string;
  size?: 'small' | 'large';
}

export const ActivityDisplay = ({
  activity,
  showLabel = false,
  size = 'large',
  customLabel,
}: ActivityDisplayProps) => {
  if (!activity) {
    return null;
  }

  const activityData = ACTIVITY[activity];
  if (!activityData) {
    return null;
  }

  const renderLabel = () => {
    if (showLabel) {
      return <div className="activity-label">{customLabel ? customLabel : activityData.key}</div>;
    }
    return null;
  };

  const iconSize = size === 'small' ? 18 : 24;
  const dimensions = { width: iconSize, height: iconSize };

  return (
    <div className={`activity-display ${activityData ? activityData.key : ''} ${size}`}>
      <img
        src={activityData.icon}
        alt={`${activityData.key} icon`}
        width={dimensions.width}
        height={dimensions.height}
      />
      {renderLabel()}
    </div>
  );
};
